import { getNoun } from '../utils/date'
import { HobbiesType } from '../types/about'

const myAge: () => number = () => {
	const birthdayYear = new Date('1999-02-05 00:00:00').getFullYear()
	return new Date().getFullYear() - birthdayYear
}

const TEXTS: string[] = [
	`Мне ${myAge()} ${getNoun(myAge(), 'год', 'года', 'лет')}
	и с 2020 я увлекся разработкой интерфейсов.
	Обучаясь на МатМехе УрФУ им. Ельцина, мне понравилась идея создавать красивые
	интерфейсы и помогать людям получать удовольствие от взаимодействия с сайтами.`,
	`Начало моей карьеры во фронтенде началось с помощи сделать сайт
	визитку для друзей, где было достаточно базовых HTML и CSS, но дальше интерфесы
	становились все сложнее и отзывчивее, как и моя эспертность в этом вопросе.`,
	`У меня обширный опыт использования разных языков программирования, но
	основным явлется JavaScript, в дполнение к реальной разработке я практикую его на LeetCode.
	Также участвовал в создании и поддержке больших и сложных
	проектов, которые позволили мне приобрести большой профессиональный опыт.`,
	`Главное удовольствие от работы я получаю, когда вижу готовый результат,
	который потрясно выгляди, быстро работает и сам подсказывает как пользователю
	делать верные шаги взаимодействия.`,
	`Я часто люблю изучать новые технологии, инструменты и подходы,
	чтобы не стоять на месте, совершенствовать свой код, подход к работе и
	понимания как устроено программирование,
	именно в этом я нахожу для себя ответ в вопросе "Что такое программирование?"`,
	`Работа в команде это - неотъемлемая часть программирования в больших проектах,
	которую я постоянно практикую и совершенствую.`,
]

const HOBBIES: HobbiesType[] = [
	{
		title: 'Проводить время с близкими',
		emoji: '👪',
	},
	{
		title: 'Путешествия',
		emoji: '🗻',
	},
	{
		title: 'Обучение новому',
		emoji: '📖',
	},
	{
		title: 'Вейкборд',
		emoji: '🏄‍♂️',
	},
	{
		title: 'Сноуборд и горные лыжи',
		emoji: '🏂',
	},
	{
		title: 'Велосипед',
		emoji: '🚴‍♂️',
	},
	{
		title: 'Просмотр кино и сериалов',
		emoji: '🎬',
	},
	{
		title: 'Посещение концертов и представлений',
		emoji: '🎭',
	},
]

export { TEXTS, HOBBIES }
